<div id="wrapper">
    <app-navbar></app-navbar>

    <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

    <div class="content-page">
        <div class="content">
            <div class="content-pane">
                <div class="container-fluid">
                    <div
                        *ngIf="sessionExpired"
                        class="alert alert-danger session-text text-center"
                        role="alert"
                    >
                        {{ errorMsg }}
                        <span class="relogin" (click)="accountLogout()"
                            >Click here to LogIn</span
                        >
                    </div>

                    <div class="breadcrumb">
                        <span class="breadcrumb-item">
                            <a href="javascript:void(0)">PayEXAP</a>
                        </span>
                        <span class="px-2"
                            ><i class="ri-arrow-right-s-line"></i
                        ></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/purchase-orders">Purchase Orders</a>
                        </span>
                        <span class="px-2"
                            ><i class="ri-arrow-right-s-line"></i
                        ></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/purchase-order-detail"
                                >Purchase Order Detail</a
                            >
                        </span>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="pane-header">
                                <h4 class="mt-2 mb-4">
                                    Purchase Order Details
                                </h4>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="detials-pane">
                                        <div class="row">
                                            <div class="col-12">
                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>Vendor Code</h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="txt-adjust">
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .vendor_code
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>Invoicing Party</h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="txt-adjust">
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .po_invoicing_party
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>PO NO.</h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="txt-adjust">
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .po_no
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>PO Value</h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="txt-adjust">
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .po_value
                                                                    | inrdisplay
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>Open PO Value</h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="txt-adjust">
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .openPoValue
                                                                    | inrdisplay
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>PO Currency</h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="txt-adjust">
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .po_currency
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>Company Code</h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="txt-adjust">
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .po_company_code
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>
                                                            Purchasing
                                                            Organisation
                                                        </h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="txt-adjust">
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .po_purchase_org
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>
                                                            Purchase Order Type
                                                        </h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="txt-adjust">
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .po_doc_type
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>
                                                            Validity End Date
                                                        </h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p
                                                            class="txt-adjust"
                                                            *ngIf="
                                                                validityExist
                                                            "
                                                        >
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .validity_end_date
                                                            }}
                                                        </p>
                                                        <p
                                                            class="txt-adjust blur"
                                                            *ngIf="
                                                                !validityExist
                                                            "
                                                        >
                                                            Not available
                                                        </p>
                                                    </div>
                                                </div>

                                                <div
                                                    class="invoice-item mb-2 row"
                                                >
                                                    <div class="col-5">
                                                        <h6>PO Payment Term</h6>
                                                    </div>
                                                    <div class="col-7">
                                                        <p
                                                            class="txt-adjust"
                                                            *ngIf="
                                                                responseData
                                                                    .pos[0]
                                                                    .po_payment_term !==
                                                                ''
                                                            "
                                                        >
                                                            {{
                                                                responseData
                                                                    .pos[0]
                                                                    .po_payment_term
                                                            }}
                                                        </p>

                                                        <p
                                                            class="txt-adjust blur"
                                                            *ngIf="
                                                                responseData
                                                                    .pos[0]
                                                                    .po_payment_term ===
                                                                ''
                                                            "
                                                        >
                                                            Not available
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <h5 class="pb-4">PO Line Items</h5>
                                    <div class="status-pane">
                                        <table
                                            aria-describedby="material-list"
                                            *ngIf="
                                                responseData.pos[0]
                                                    .po_ses_mat == 'MAT'
                                            "
                                            class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint"
                                            data-page-size="5"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Line Item</th>
                                                    <th>Item Code</th>
                                                    <th>Item Description</th>

                                                    <th>Item Quantity</th>
                                                    <th>Item Open Quantity</th>
                                                    <th>Delivery Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="
                                                        let lineItem of responseData
                                                            .pos[0].line_items
                                                    "
                                                >
                                                    <td>
                                                        {{
                                                            lineItem.po_item_line
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            lineItem.po_item_material_code
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            lineItem.po_item_description
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            lineItem.po_item_quantity
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            lineItem.open_item_quantity
                                                        }}
                                                    </td>
                                                    <td
                                                        *ngIf="
                                                            deliveryDateExist
                                                        "
                                                    >
                                                        {{
                                                            lineItem.item_delivery_date
                                                        }}
                                                    </td>
                                                    <td
                                                        *ngIf="
                                                            !deliveryDateExist
                                                        "
                                                    >
                                                        NA
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table
                                            aria-describedby="service-list"
                                            *ngIf="
                                                responseData.pos[0]
                                                    .po_ses_mat == 'SERV'
                                            "
                                            class="table mb-0 toggle-arrow-tiny tablet breakpoint"
                                            data-page-size="5"
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        data-toggle="true"
                                                        class="footable-visible footable-first-column footable-sortable"
                                                    >
                                                        Line Item
                                                    </th>
                                                    <th
                                                        class="footable-visible footable-sortable"
                                                    >
                                                        Item Description
                                                    </th>

                                                    <th
                                                        class="footable-visible footable-sortable"
                                                    >
                                                        Item Quantity
                                                    </th>
                                                    <th>Delivery Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    class="footable-even footable-detail-show"
                                                    *ngFor="
                                                        let lineItem of lineItems
                                                    "
                                                >
                                                    <td>
                                                        {{
                                                            lineItem.po_item_line
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            lineItem.po_item_description
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            lineItem.po_item_quantity
                                                        }}
                                                    </td>
                                                    <td
                                                        *ngIf="
                                                            deliveryDateExist
                                                        "
                                                    >
                                                        {{
                                                            lineItem.item_delivery_date
                                                        }}
                                                    </td>
                                                    <td
                                                        *ngIf="
                                                            !deliveryDateExist
                                                        "
                                                    >
                                                        NA
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- <div class="bar-code mt-3">
                      <h5>Invoice BarCode</h5>
                      <img src="assets/images/bar-cod.png" alt="" />
                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
